// 260805nrai: Safe Foundation Reveal open + PDFObject embed for attachment / AZ PDF icons.
// Attachments/_list.html.erb had this locally; /azs and employee AZ tab did not → empty modal
// or Foundation open() crashing with "Cannot read properties of null (reading 'defaultView')"
// when the modal lookup failed / ran on a detached node.

(function () {
  function modalIdFromEl(el) {
    if (!el || !el.getAttribute) return null;
    return el.getAttribute('data-reveal-id');
  }

  function closestRevealTrigger(start) {
    var el = start;
    while (el && el !== document) {
      if (el.getAttribute && el.getAttribute('data-reveal-id')) return el;
      el = el.parentNode;
    }
    return null;
  }

  function ensureRevealInitialized($modal) {
    if (!$modal.length) return;
    if (!$modal.data('reveal')) {
      try {
        $modal.foundation('reveal');
      } catch (e) {
        // ignore double-init races
      }
    }
  }

  function resolvePdfUrl($container) {
    var url =
      $container.attr('data-pdf-url') ||
      $container.data('pdfUrl') ||
      $container.data('pdf-url');
    if (url) return url;

    var containerId = $container.attr('id');
    if (!containerId || typeof jQuery === 'undefined') return null;

    var $trigger = jQuery('[data-pdf-target="' + containerId + '"]').first();
    if (!$trigger.length) return null;
    return (
      $trigger.attr('data-pdf-url') ||
      $trigger.data('pdfUrl') ||
      $trigger.data('pdf-url') ||
      null
    );
  }

  function embedPdfIfNeeded($modal) {
    if (typeof PDFObject === 'undefined' || !$modal || !$modal.length) return;

    var $container = $modal.find('[id^="pdf_container_"]').first();
    if (!$container.length) return;

    // :empty fails if ERB left whitespace text nodes — only skip when already embedded
    if ($container.children().length > 0) return;

    var containerId = $container.attr('id');
    var url = resolvePdfUrl($container);
    if (!url) return;

    PDFObject.embed(url, '#' + containerId, {
      pdfOpenParams: { view: 'FitV', page: '1' },
      fallbackLink:
        "<p>PDF konnte nicht angezeigt werden. <a href='" +
        url +
        "'>Hier herunterladen</a>.</p>"
    });
  }

  function openPdfReveal(triggerEl) {
    var modalId = modalIdFromEl(triggerEl);
    if (!modalId || typeof jQuery === 'undefined') return false;

    var $modal = jQuery('#' + modalId);
    if (!$modal.length) return false;

    var isPdfReveal =
      triggerEl.hasAttribute('data-pdf-url') ||
      (triggerEl.classList && triggerEl.classList.contains('pdf_trigger')) ||
      $modal.find('[id^="pdf_container_"]').length > 0;
    if (!isPdfReveal) return false;

    ensureRevealInitialized($modal);
    try {
      $modal.foundation('reveal', 'open');
    } catch (err) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('badok PDF reveal open failed', modalId, err);
      }
    }

    // Embed after open animation / body move (do not rely only on namespaced opened.*)
    setTimeout(function () {
      embedPdfIfNeeded(jQuery('#' + modalId));
    }, 50);
    setTimeout(function () {
      embedPdfIfNeeded(jQuery('#' + modalId));
    }, 350);

    return true;
  }

  function bindHandlers() {
    if (window.__badokAttachmentPdfRevealBound) return;
    window.__badokAttachmentPdfRevealBound = true;

    // Capture phase: run before Foundation's bubble handler (avoids defaultView crash).
    document.addEventListener(
      'click',
      function (e) {
        var trigger = closestRevealTrigger(e.target);
        if (!trigger) return;
        if (!openPdfReveal(trigger)) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      },
      true
    );

    if (typeof jQuery !== 'undefined') {
      // 260805nrai: must match Foundation's trigger namespaces exactly —
      // opened.fndtn.reveal.EXTRA does NOT fire for trigger('opened.fndtn.reveal').
      jQuery(document).on('opened.fndtn.reveal', function (e) {
        embedPdfIfNeeded(jQuery(e.target));
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindHandlers);
  } else {
    bindHandlers();
  }
})();
